/*
    THIS FILE IS OWNED BY TEAM AM I LEFT
*/
export enum ProgramManagementFeatureFlags {
    EnableFilteredFacilityExport = 'ENABLE_JOB_INFO_REPOSITORY_GET_FACILITIES_SECONDARY_SORT_BY_ID',
    UseNewSendToClientRichTextEditor = 'USE_NEW_SEND_TO_CLIENT_RICH_TEXT_EDITOR',
    WorkingCandidatesGridExtensionRequestShowBlueE = 'WORKING_CANDIDATES_GRID_CANDIDATE_EXTENSION_REQUESTED_SHOW_BLUE_E',
    ShowExtensionRequestsInRecruiterDashboard = 'SHOW_EXTENSION_REQUESTS_IN_RECRUITER_DASHBOARD',
    UseNewJobImporter = 'USE_NEW_JOB_IMPORTER',
    UseImprovedFilterLogicIntegrationMapping = 'USE_IMPROVED_FILTER_LOGIC_INTEGRATION_MAPPING',
    IncludeAdditionalAccountFieldsFacilityProfiles = 'include-additional-account-fields-facility-profiles',
    EnablePositionReleaseStatusBehavior = 'enable-position-release-status-behavior',
    NeonTigerEnableSelectiveFieldMappingOnCorrection = 'neon-tiger-enable-selective-field-mapping-on-correction',
    NeonTigerEnableErrorReporting = 'neon-tiger-enable-error-reporting',
    NeonTigerEmableProfessionSpecialtyMappingDetail = 'neon-tiger-enable-profession-specialty-mapping-detail',
    NeonTigerEnablePerformanceReport = 'neon-tiger-enable-performance-report',
    NeonTigerUseJobLocks = 'neon-tiger-use-job-locks',
    NeonTigerJobImporterFacilityMappingDetails = 'nt-job-importer-facility-mapping-details',
    NeonTigerIncludeUserInfoInRuleDetails = 'neon-tiger-include-user-info-in-rule-details',
    AccountManagersValidateJobGridPageSize = 'account-managers-validate-job-grid-page-size',
    FixSharedFacilitySystemFilterVirtualScroll = 'fix-shared-facility-system-filter-virtual-scroll',
    NeonTigerShowVendorSettingsJobsGrid = 'neon-tiger-display-vendor-jobs',
    JobImporterReportingAdditionalMetrics = 'pm-1495-job-importer-reporting-additional-metrics',
    NeonTigerSetCreatedByModifiedBy = 'neon-tiger-set-createdby-modifiedby',
    AddLockIconToJobsGrid = 'add-lock-icon-to-jobs-grid',
    NeonTigerFixPostedBy = 'neon-tiger-fix-posted-by-job-info',
    NeonTigerDisplayMappingIds = 'neon-tiger-display-mapping-ids',
    JobsGridClearSelectionWhenFiltering = 'jobs-grid-clear-selection-when-filtering',
    ShowSubmittalsInAmJobsGrid = 'view-submittals-am-jobs-grid',
    NeonTigerSortVendorJobHistory = 'neon-tiger-sort-vendor-job-history',
    NovaAmWocFixModifiedByLookup = 'nova-am-woc-fix-modified-by-lookup',
    ClearBonusesForDuplicateJob = 'clear-bonus-am-duplicated-jobs',
    NovaSkeletonLoader = 'nova-skeleton-loader',
    NeonTigerManuallyImportJobFromBullhorn = 'neon-tiger-manually-import-job-from-bullhorn',
    NeonTigerShiftScheduleSupport = 'nt-shift-schedule-support',
    AccountManagerEnableJobHistory = 'account-manager-enable-job-history',
    AccountManagerWocExportUsingAccountManagerId = 'export-am-woc-using-userid',
    AmJobDetailsRemoveUnnecessaryApiCalls = 'am-job-details-remove-extra-calls'
}
